module.exports = __webpack_public_path__ + "img/10.10248a6f.jpg";